// Civala geometric mark — outer navy ring + inner accent-blue dot.
// Per Gregg McConnell v2 site update (May 2026): paired with the
// Playfair Display "civala" wordmark in TopNav and Footer. The mark
// uses the same `--pitch-navy` (medium) + `--pitch-accent` token pair
// as buttons/borders elsewhere on the pitch site.

type Props = {
  size?: number
  /** Override the ring color (defaults to var(--pitch-navy)). */
  ringColor?: string
  /** Override the dot color (defaults to var(--pitch-accent)). */
  dotColor?: string
}

export function CivalaMark({ size = 18, ringColor = "var(--pitch-navy)", dotColor = "var(--pitch-accent)" }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" style={{ flexShrink: 0 }} aria-hidden="true">
      <circle cx="9" cy="9" r="8" fill="none" stroke={ringColor} strokeWidth="1.5" />
      <circle cx="9" cy="9" r="2.5" fill={dotColor} />
    </svg>
  )
}
